import { useState, useEffect } from "react";

const mobileWidth = 700;

export default function useWindowDimensions(params?: { listenForResize?: boolean }) {
  const [windowSize, setWindowSize] = useState({
    width: global?.window === undefined ? 0 : window?.innerWidth,
    height: global?.window === undefined ? 0 : window?.innerHeight,
    isMobile: false,
  });

  const listenForResize = params?.listenForResize ?? true;

  useEffect(() => {
    if (!global?.window) return;
    function handleResize() {
      const width = window?.innerWidth ?? 0;
      setWindowSize({
        width: width,
        height: window?.innerHeight ?? 0,
        isMobile: width <= mobileWidth,
      });
    }
    handleResize();
    if (listenForResize) {
      window?.addEventListener("resize", handleResize);
    }
    return () => {
      if (listenForResize) {
        window?.removeEventListener("resize", handleResize);
      }
    };
  }, [listenForResize]);

  return windowSize;
}
